/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ManagementCompanyBoardMemberDto } from '../../models/management-company-board-member-dto';

export interface ReactivateBoardMember$Params {
  managementCompanyId: string;
  boardMemberId: string;
}

export function reactivateBoardMember(http: HttpClient, rootUrl: string, params: ReactivateBoardMember$Params, context?: HttpContext): Observable<StrictHttpResponse<ManagementCompanyBoardMemberDto>> {
  const rb = new RequestBuilder(rootUrl, reactivateBoardMember.PATH, 'post');
  if (params) {
    rb.path('managementCompanyId', params.managementCompanyId, {});
    rb.path('boardMemberId', params.boardMemberId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ManagementCompanyBoardMemberDto>;
    })
  );
}

reactivateBoardMember.PATH = '/management-companies/{managementCompanyId}/board-members/{boardMemberId}/reactivate';
